import { render } from "./base-error-boundary-error-list.vue?vue&type=template&id=29214444&ts=true"
import script from "./base-error-boundary-error-list.vue?vue&type=script&lang=ts"
export * from "./base-error-boundary-error-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__